import { resolveCmsDevProxyUrl } from './cms-dev-proxy-url';
import {
  getConfiguredCmsOrigin,
  shouldUseCmsDevProxy,
} from './cms-origin';
import { getCurrentToken, getMode } from './session-token.js';

let aiRequestSpotId: string | null = null;

/** Spot-Kontext für AI-API-Requests (Graph-Validierung im CMS). */
export function setAiRequestContext(context: { spotId: string }): void {
  aiRequestSpotId = context.spotId;
}

export function getAiRequestSpotId(): string | null {
  return aiRequestSpotId;
}

export function cmsApiRoot(): string {
  if (shouldUseCmsDevProxy()) {
    return '/__cms';
  }
  return getConfiguredCmsOrigin();
}

export function cmsApiUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${cmsApiRoot()}${normalized}`;
}

export function resolveCmsAssetRefUrl(url: string | undefined): string | undefined {
  if (!url) return undefined;
  return resolveCmsDevProxyUrl(url) ?? url;
}

/** Request-Header fuer CMS-AI-Endpoints (Draft-Modus: Editor-Bearer-Token). */
export function buildCmsAiRequestHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json'
  };
  const token = getCurrentToken();
  if (getMode() === 'draft' && token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

export async function readCmsApiErrorMessage(response: Response): Promise<string> {
  try {
    const payload = (await response.json()) as {
      message?: string;
      statusMessage?: string;
      data?: string | { message?: string };
    };
    const dataDetail =
      typeof payload.data === 'string'
        ? payload.data
        : payload.data?.message;
    return (
      dataDetail ??
      payload.message ??
      payload.statusMessage ??
      response.statusText
    );
  } catch {
    return response.statusText || `HTTP ${response.status}`;
  }
}
